<template>
  <f7-page class="launch-screen">
    <f7-block>
      <div class="placeholder">
        <img src="~@/assets/logo.png"/>
        <div class="placeholder__inner">
        </div>
        <div class="placeholder__text">
        </div>
      </div>
    </f7-block>
  </f7-page>
</template>

<script>
export default {
}
</script>
<style scoped lang="scss">
  .placeholder {
    display: flex;
    flex-direction: column;
    /*flex-wrap: wrap;*/
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .placeholder__inner {
    width: 200px;
    height: 200px;
    max-width: 100%;
  }

  .launch-screen {
    background-color: #5b5b5b;
  }

  .launch-screen {
    background-color: rgba(255, 255, 255, 1);
    background: radial-gradient(ellipse at center, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(237, 237, 237, 1) 100%);
  }

  .carrier__image {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// launch-screen.page.vue?b1d25794